var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.285 5.30413C16.7339 4.85542 17.3427 4.6034 17.9774 4.60352C18.612 4.60363 19.2207 4.85588 19.6694 5.30476C20.1181 5.75364 20.3702 6.36239 20.37 6.99709C20.3699 7.63179 20.1177 8.24044 19.6688 8.68916L18.7525 9.60416L15.3663 6.22164L16.2838 5.30413H16.285ZM14.485 7.1054L7.03996 14.5479C6.81398 14.7741 6.64366 15.0497 6.54246 15.353L5.39995 18.7817C5.36346 18.8917 5.35827 19.0097 5.38499 19.1225C5.4117 19.2353 5.46926 19.3385 5.55122 19.4205C5.63319 19.5024 5.73634 19.56 5.84913 19.5867C5.96193 19.6134 6.07994 19.6082 6.18996 19.5717L9.61873 18.4292C9.92248 18.3292 10.1975 18.158 10.4237 17.9317L17.8688 10.4892L14.4838 7.1054H14.485Z",
    fill: "current"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFilled);
export default __webpack_public_path__ + "static/media/edit_filled.00e06f1a.svg";
export { ForwardRef as ReactComponent };